module.exports = {
  name: 'masthead-carousel',
  settings: {
    set: [
      { width: 1024, breakpoint: 'xs' },
      { width: 1280, breakpoint: 'md' },
      { width: 1600, breakpoint: 'lg' },
    ],
    ratio: null,
    fit: 'crop',
    align: 'center',
  },
}